/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-computed-key */
import React, { useContext, useState, useEffect, useRef } from "react";
import "./Dropdown.css";
import "./LoadingPage.css";
import { jsPDF } from "jspdf";
import "rc-slider/assets/index.css";
import { useParams, useNavigate } from "react-router-dom";
import DropdownContext from "./DropdownContext";
import ColorSelect from "./ColorSelect";
import CreatableSelect from "react-select/creatable";
import { RiExpandUpDownLine } from "react-icons/ri";
import { FaCheck } from "react-icons/fa6";

function DropdownPage() {
  const { dropdownState, setDropdownState } = useContext(DropdownContext) || {
    textAreaContentOeil: "",
  };
  console.log("DropdownPage :", dropdownState.textAreaContentOeil);
  console.log(dropdownState.winecode);
  const { pageId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [formName, setFormName] = useState("");
  const [isExpandedBouche, setIsExpandedBouche] = useState(false);
  const [isExpandedEnsemble, setIsExpandedEnsemble] = useState(false);
  const [isExpandedOeil, setIsExpandedOeil] = useState(false);
  const [isExpandedNez, setIsExpandedNez] = useState(false);
  const [isExpandedComment, setIsExpandedComment] = useState(false);
  const [isExpandedNote, setIsExpandedNote] = useState(false);
  const [wineRatings, setWineRatings] = useState({});
  const [personalRating, setPersonalRating] = useState(0);

  const toggleBoucheDropdown = () => {
    setIsExpandedBouche(!isExpandedBouche);
  };

  const toggleEnsembleDropdown = () => {
    setIsExpandedEnsemble(!isExpandedEnsemble);
  };

  const toggleOeilDropdown = () => {
    setIsExpandedOeil(!isExpandedOeil);
  };

  const toggleNezDropdown = () => {
    setIsExpandedNez(!isExpandedNez);
  };

  const toggleCommentDropdown = () => {
    setIsExpandedComment(!isExpandedComment);
  };

  const toggleNoteDropdown = () => {
    setIsExpandedNote(!isExpandedNote);
  };

  const handleNameChange = (e) => {
    setFormName(e.target.value);
  };

  const handleEnsembleAnswer = (key, value) => {
    setDropdownState((prev) => ({
      ...prev,
      vueDensemble: {
        ...prev.vueDensemble,
        [key]: value,
      },
    }));
    console.log("vueDensemble:", dropdownState.vueDensemble);
  };

  const questions = [
    { key: "harmonieux", label: "Vin harmonieux ?" },
    { key: "complexe", label: "Vin complexe ?" },
    { key: "long_en_bouche", label: "Vin long en bouche ?" },
  ];

  const handleSubmit = async () => {
    try {
      // Include the email in the form data
      const formData = {
        ...dropdownState,
        email, // Add the email to the form datas
        date: new Date(), // Add the current date to the form datas
      };
      console.log(formData);

      // Send a POST request to the serverless function
      const response = await fetch("/api/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json();
      console.log("Data successfully sent to MongoDB:", result);
      navigate("/");
    } catch (error) {
      console.error("Error submitting the data:", error);
    }
  };

  const handleColorChange = (color) => {
    setDropdownState((prevState) => ({
      ...prevState,
      ["selectedColor"]: color,
    }));
  };

  const handleStarClick = (index) => {
    setDropdownState((prevState) => ({
      ...prevState,
      ["personalRating"]: index,
    }));
  };

  const options = [
    { value: "option1", label: "citron" },
    { value: "option2", label: "pamplemousse" },
    { value: "option3", label: "orange" },
    { value: "option4", label: "ananas" },
    { value: "option5", label: "banane" },
    { value: "option6", label: "litchi" },
    { value: "option7", label: "melon" },
    { value: "option8", label: "muscat" },
    { value: "option9", label: "pomme" },
    { value: "option10", label: "poire" },
    { value: "option11", label: "coing" },
    { value: "option12", label: "fraise" },
    { value: "option13", label: "framboise" },
    { value: "option14", label: "groseille" },
    { value: "option15", label: "cassis" },
    { value: "option16", label: "myrtille" },
    { value: "option17", label: "mûre" },
    { value: "option18", label: "cerise" },
    { value: "option19", label: "abricot" },
    { value: "option20", label: "pêche" },
    { value: "option21", label: "amande (frangipane)" },
    { value: "option22", label: "pruneau" },
    { value: "option23", label: "noix" },
    { value: "option24", label: "aubépine" },
    { value: "option25", label: "acacia" },
    { value: "option26", label: "tilleul" },
    { value: "option27", label: "miel" },
    { value: "option28", label: "rose" },
    { value: "option29", label: "violette" },
    { value: "option30", label: "poivron vert" },
    { value: "option31", label: "champignon" },
    { value: "option32", label: "truffe" },
    { value: "option33", label: "lie de vin" },
    { value: "option34", label: "cèdre" },
    { value: "option35", label: "pin" },
    { value: "option36", label: "réglisse" },
    { value: "option37", label: "bourgeon de cassis (ou buis)" },
    { value: "option38", label: "foin coupé" },
    { value: "option39", label: "thym" },
    { value: "option40", label: "vanille" },
    { value: "option41", label: "cannelle" },
    { value: "option42", label: "clou de girofle" },
    { value: "option43", label: "poivre" },
    { value: "option44", label: "safran" },
    { value: "option45", label: "cuir" },
    { value: "option46", label: "musc" },
    { value: "option47", label: "beurre" },
    { value: "option48", label: "pain grillé" },
    { value: "option49", label: "amande grillée" },
    { value: "option50", label: "noisette grillée" },
    { value: "option51", label: "caramel" },
    { value: "option52", label: "café" },
    { value: "option53", label: "chocolat noir" },
    { value: "option54", label: "note fumée" },
  ];

  const handleInputChange = (field, value) => {
    setDropdownState((prevState) => ({ ...prevState, [field]: value }));
  };

  const handleEdit = (field) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [`IsEditing${field}`]: true,
    }));
  };

  const handleSave = (field) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [`Saved${field}`]: prevState[field],
      [`IsEditing${field}`]: false,
    }));
  };

  const handleSelectChange = (selectedOptions, dropdown) => {
    setDropdownState((prevState) => {
      const updatedState = {
        ...prevState,
        [dropdown]: Array.isArray(selectedOptions)
          ? selectedOptions.map((option) => option.value) // Multi-select handling
          : selectedOptions?.value, // Single select handling
      };
      return updatedState;
    });
  };

  const handleSliderChange = (value, ratingName) => {
    setDropdownState((prevState) => ({ ...prevState, [ratingName]: value }));
  };

  const handleSliderSmileyChange = (value, ratingName) => {
    setDropdownState((prevState) => ({ ...prevState, [ratingName]: value }));
  };

  const [email, setEmail] = useState("");
  const [isSending, setIsSending] = useState(false);

  const generatePDF = async (content) => {
    const pdf = new jsPDF();
    pdf.text(content, 10, 10);
    return pdf.output("blob");
  };

  const wineLists = {
    RG: [
      { paramName: "acidite", displayName: "Acidité" },
      { paramName: "douceur", displayName: "Douceur" },
      { paramName: "tanins", displayName: "Tanins" },
      { paramName: "alcool", displayName: "Alcool" },
    ],
    RZ: [
      { paramName: "acidite", displayName: "Acidité" },
      { paramName: "douceur", displayName: "Douceur" },
      { paramName: "tanins", displayName: "Tanins" },
      { paramName: "alcool", displayName: "Alcool" },
    ],
    B: [
      { paramName: "acidite", displayName: "Acidité" },
      { paramName: "douceur", displayName: "Douceur" },
      { paramName: "alcool", displayName: "Alcool" },
    ],
    EF: [
      { paramName: "intensite", displayName: "Intensité" },
      { paramName: "acidite", displayName: "Acidité" },
      { paramName: "douceur", displayName: "Douceur" },
      { paramName: "alcool", displayName: "Alcool" },
      { paramName: "volume", displayName: "Volume" },
      {
        paramName: "description_des_bulles",
        displayName: "Description des bulles",
      },
    ],
  };

  const getListItems = (input) => {
    try {
      if (typeof input !== "string") {
        throw new Error("Input must be a string");
      }

      if (input.startsWith("RG")) return wineLists.RG;
      if (input.startsWith("RZ")) return wineLists.RZ;
      if (input.startsWith("B")) return wineLists.B;
      if (input.startsWith("EF")) return wineLists.EF;

      return wineLists.RG; // Default list
    } catch (error) {
      return wineLists.RG; // Return an empty array or default value in case of an error
    }
  };

  const handleTextareaChangeOeil = (e) => {
    const input = e.target.value;
    setDropdownState((prevState) => ({
      ...prevState,
      textAreaContentOeil: input || dropdownState.winecode, // Valeur par défaut pour éviter undefined
    }));
    updateColorOptions(input);
  };

  const [colorOptions, setColorOptions] = useState([]);

  useEffect(() => {
    const code = dropdownState?.textAreaContentOeil || "";
    if (code.startsWith("RG")) {
      setColorOptions([
        { value: "option1", label: "Violacé", color: "#743754" },
        { value: "option2", label: "Rubis", color: "#a30525" },
        { value: "option3", label: "Grenat", color: "#b4211e" },
        { value: "option4", label: "Tuilé", color: "#8f4318" },
      ]);
    } else if (code.startsWith("RZ")) {
      setColorOptions([
        { value: "option1", label: "Pâle", color: "#f2b3c8" },
        { value: "option2", label: "Saumon", color: "#ef998c" },
        { value: "option3", label: "Pelure d'oignon", color: "#f2a480" },
        { value: "option4", label: "Framboise", color: "#d04b82" },
      ]);
    } else if (code.startsWith("B") || code.startsWith("EF")) {
      setColorOptions([
        { value: "option1", label: "Jaune vert", color: "#e3ff00" },
        { value: "option2", label: "Jaune citron", color: "#faff00" },
        { value: "option3", label: "Jaune doré", color: "#ffe500" },
        { value: "option4", label: "Ambré", color: "#e4a400" },
      ]);
    } else {
      setColorOptions([
        { value: "option1", label: "Violacé", color: "#743754" },
        { value: "option2", label: "Rubis", color: "#a30525" },
        { value: "option3", label: "Grenat", color: "#b4211e" },
        { value: "option4", label: "Tuilé", color: "#8f4318" },
      ]);
    }
  }, [dropdownState?.textAreaContentOeil]);

  const updateColorOptions = (input) => {
    if (input.startsWith("RG")) {
      setColorOptions([
        { value: "option1", label: "Violacé", color: "#743754" },
        { value: "option2", label: "Rubis", color: "#a30525" },
        { value: "option3", label: "Grenat", color: "#b4211e" },
        { value: "option4", label: "Tuilé", color: "#8f4318" },
      ]);
    } else if (input.startsWith("RZ")) {
      setColorOptions([
        { value: "option1", label: "Pâle", color: "#f2b3c8" },
        { value: "option2", label: "Saumon", color: "#ef998c" },
        { value: "option3", label: "Pelure d'oignon", color: "#f2a480" },
        { value: "option4", label: "Framboise", color: "#d04b82" },
      ]);
    } else if (input.startsWith("B")) {
      setColorOptions([
        { value: "option1", label: "Jaune vert", color: "#e3ff00" },
        { value: "option2", label: "Jaune citron", color: "#faff00" },
        { value: "option3", label: "Jaune doré", color: "#ffe500" },
        { value: "option4", label: "Ambré", color: "#e4a400" },
      ]);
    } else if (input.startsWith("EF")) {
      setColorOptions([
        { value: "option1", label: "Jaune vert", color: "#e3ff00" },
        { value: "option2", label: "Jaune citron", color: "#faff00" },
        { value: "option3", label: "Jaune doré", color: "#ffe500" },
        { value: "option4", label: "Ambré", color: "#e4a400" },
      ]);
    } else {
      setColorOptions([
        { value: "option1", label: "Violacé", color: "#743754" },
        { value: "option2", label: "Rubis", color: "#a30525" },
        { value: "option3", label: "Grenat", color: "#b4211e" },
        { value: "option4", label: "Tuilé", color: "#8f4318" },
      ]); // Default options
    }
  };

  const listItems = getListItems(dropdownState?.textAreaContentOeil || "");

  const handleSavePage = () => {
    const wineCode = dropdownState.winecode;

    if (!["R", "RZ", "B", "EF"].includes(wineCode.charAt(0))) {
      alert("Entrez un nom de code commençant par R, RZ, EF ou B.");
      return;
    }

    const savedPages = JSON.parse(localStorage.getItem("pages")) || [];
    const currentPage = {
      id: pageId, // Associate the page with its unique ID
      name: wineCode,
      data: {
        selectedOption1: dropdownState.selectedOption1,
        selectedOption2: dropdownState.selectedOption2,
        TextAreaContent: dropdownState.TextAreaContent,
        textAreaComment: dropdownState.textAreaComment,
        textAreaContentOeil: dropdownState.textAreaContentOeil,
        selectedColor: dropdownState.selectedColor,
        date: dropdownState.date,
        WineName: dropdownState.WineName,
        intensite: dropdownState.acidite,
        douceur: dropdownState.douceur,
        acidite: dropdownState.acidite,
        alcool: dropdownState.alcool,
        tanins: dropdownState.tanins,
        volume: dropdownState.volume,
        longeur_en_bouche: dropdownState.longeur_en_bouche,
        smileyRating: dropdownState.smileyRating,
        intensiteNez: dropdownState.intensiteNez,
        wineRatings: dropdownState.wineRatings,
        personalRating: dropdownState.personalRating,
        showMoreTextarea: dropdownState.showMoreTextarea,
        textAreaMore: dropdownState.textAreaMore,
        vueDensemble: dropdownState.vueDensemble,
        selectedOptionNezBis: dropdownState.selectedOptionNezBis,
      },
    };

    console.log(currentPage);

    const existingPageIndex = savedPages.findIndex(
      (page) => page.id === pageId
    );

    if (existingPageIndex > -1) {
      savedPages[existingPageIndex] = currentPage; // Update the existing page
    } else {
      savedPages.push(currentPage); // Add a new page
    }

    localStorage.setItem("pages", JSON.stringify(savedPages));

    navigate("/homepage"); // Redirect to homepage or another page
  };

  return (
    <div className="dropdown-pop">
      {/* 
      <div className="btn-close-pop">
        <TfiClose
          className="btn-close-style"
          size={24}
          onClick={handleSavePage}
        />
      </div>
      */}
      <div className="white-bloc">
        <div className="input-container">
          <div className="wine-name-bloc">
            <div className="bloc-saveWineName">
              <textarea
                maxLength={20}
                placeholder="Code du Vin"
                name="WineName"
                className="WineName"
                rows="1"
                value={dropdownState.winecode}
                onFocus={() =>
                  setDropdownState({
                    ...dropdownState,
                    textAreaContentOeil:
                      dropdownState.textAreaContentOeil || "",
                  })
                }
                onBlur={() =>
                  setDropdownState({
                    ...dropdownState,
                    textAreaContentOeil:
                      dropdownState.textAreaContentOeil.trim() || "",
                  })
                }
                onChange={handleTextareaChangeOeil}
              ></textarea>
              <button onClick={() => handleSave("WineName")}>
                <FaCheck size={27} />
              </button>
            </div>
          </div>
        </div>
        <div className="dropdown-container eye-style">
          <h3 className="dropdown-list-h3" onClick={toggleOeilDropdown}>
            L'Œil
            <RiExpandUpDownLine size={22} className="chevron-position" />
          </h3>
          {isExpandedOeil && (
            <ColorSelect
              colors={colorOptions}
              selectedColor={dropdownState.selectedColor}
              onColorChange={handleColorChange}
            />
          )}
        </div>
        <div className="dropdown-container">
          <h3 className="dropdown-list-h3" onClick={toggleNezDropdown}>
            Le Nez
            <RiExpandUpDownLine size={22} className="chevron-position" />
          </h3>

          {isExpandedNez && (
            <div className="nez-container">
              <CreatableSelect
                isMulti
                name="nez"
                options={options}
                className="basic-multi-select select"
                placeholder="Sélectionner le nez"
                classNamePrefix="custom-select"
                isClearable={false} // 🔹 Désactive la croix qui supprime toutes les options
                value={dropdownState["selectedOption2"]?.map(
                  (value) =>
                    options.find((option) => option.value === value) || {
                      label: value,
                      value,
                    }
                )}
                onChange={(selectedOptions) =>
                  handleSelectChange(selectedOptions, "selectedOption2")
                }
                styles={{
                  clearIndicator: (base) => ({
                    ...base,
                    display: "none",
                  }),
                }}
              />
            </div>
          )}
        </div>

        <div className="dropdown-container">
          <h3 className="dropdown-list-h3" onClick={toggleBoucheDropdown}>
            La Bouche
            <RiExpandUpDownLine size={22} className="chevron-position" />
          </h3>

          {isExpandedBouche && (
            <>
              <div className="question-container">
                <h5>Par rapport au nez, je sens :</h5>
                <div className="button-group">
                  <button
                    className={`btn-more ${
                      dropdownState.showMoreTextarea === "more"
                        ? "selected"
                        : ""
                    }`}
                    onClick={() =>
                      setDropdownState((prevState) => ({
                        ...prevState,
                        showMoreTextarea: "more",
                      }))
                    }
                  >
                    Plus d'arômes
                  </button>
                  <button
                    className={`btn-same ${
                      dropdownState.showMoreTextarea === "same"
                        ? "selected"
                        : ""
                    }`}
                    onClick={() =>
                      setDropdownState((prevState) => ({
                        ...prevState,
                        showMoreTextarea: "same",
                      }))
                    }
                  >
                    Pareil
                  </button>
                  <button
                    className={`btn-less ${
                      dropdownState.showMoreTextarea === "less"
                        ? "selected"
                        : ""
                    }`}
                    onClick={() =>
                      setDropdownState((prevState) => ({
                        ...prevState,
                        showMoreTextarea: "less",
                      }))
                    }
                  >
                    Moins d'arômes
                  </button>
                </div>
                {dropdownState.showMoreTextarea === "more" && (
                  <div className="textarea-container">
                    <CreatableSelect
                      isMulti
                      name="aromes-bouche"
                      options={options}
                      className="basic-multi-select select"
                      placeholder="Lesquels ?"
                      classNamePrefix="custom-select"
                      value={dropdownState["selectedOptionNezBis"]?.map(
                        (value) =>
                          options.find((option) => option.value === value) || {
                            label: value,
                            value,
                          }
                      )}
                      onChange={(selectedOptions) =>
                        handleSelectChange(
                          selectedOptions,
                          "selectedOptionNezBis"
                        )
                      }
                    />
                  </div>
                )}
              </div>
              <div className="grid-container">
                {listItems.map((ratingName) => (
                  <div
                    key={ratingName.paramName}
                    className="rating-container flex-left"
                    id="spanRating"
                  >
                    <label>{ratingName.displayName}</label>
                    <div className="circle-container">
                      {[1, 2, 3].map((index) => (
                        <div
                          key={index}
                          className="circle-style"
                          style={{
                            backgroundColor:
                              dropdownState[ratingName.paramName] >= index
                                ? "#547d9d"
                                : "transparent",
                            opacity:
                              dropdownState[ratingName.paramName] >= index
                                ? 1
                                : 0.3,
                          }}
                          onClick={() => {
                            const currentValue =
                              dropdownState[ratingName.paramName];
                            const newValue = currentValue === index ? 0 : index;
                            handleSliderChange(newValue, ratingName.paramName);
                          }}
                        ></div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div className="dropdown-container commentaire-container">
          <h3 className="dropdown-list-h3" onClick={toggleCommentDropdown}>
            Commentaire
            <RiExpandUpDownLine size={22} className="chevron-position" />
          </h3>
          {isExpandedComment && (
            <textarea
              className="txt-commentaire-2"
              placeholder="Laissez votre commentaire..."
              value={dropdownState.textAreaComment}
              onChange={(e) =>
                handleInputChange("textAreaComment", e.target.value)
              }
            ></textarea>
          )}
        </div>
        <div className="dropdown-container">
          <h3 className="dropdown-list-h3" onClick={toggleEnsembleDropdown}>
            Vue d'ensemble
            <RiExpandUpDownLine size={22} className="chevron-position" />
          </h3>
          {isExpandedEnsemble && (
            <>
              <div className="question-container-ens">
                {questions.map(({ key, label }) => (
                  <div key={key} className="question-block">
                    <p>{label}</p>
                    <div className="button-group-ens">
                      <button
                        type="button"
                        className={`btn-yes ${
                          dropdownState.vueDensemble?.[key] === "Oui"
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => handleEnsembleAnswer(key, "Oui")}
                        aria-pressed={
                          dropdownState.vueDensemble?.[key] === "Oui"
                        }
                      >
                        Oui
                      </button>
                      <button
                        type="button"
                        className={`btn-no ${
                          dropdownState.vueDensemble?.[key] === "Non"
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => handleEnsembleAnswer(key, "Non")}
                        aria-pressed={
                          dropdownState.vueDensemble?.[key] === "Non"
                        }
                      >
                        Non
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
        <div className="rating-container flex-center">
          {/* 
                        <h3
                        className="dropdown-list-h3 notation-position"
                        onClick={toggleNoteDropdown}
                        >
                        {"Ma Notation"}
                        {isExpandedNote ? (
                          <RiExpandUpDownLine size={24} className="chevron-position" />
                        ) : (
                          <RiExpandUpDownLine size={24} className="chevron-position" />
                        )}{" "}
                        </h3>
                        {isExpandedNote && (*/}
          <div className="personal-rating">
            <label className="personal-rating-label">Ma note perso</label>
            <div className="star-container">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`star ${
                    star <= dropdownState.personalRating ? "filled" : ""
                  }`}
                  onClick={() => handleStarClick(star)}
                >
                  ★
                </span>
              ))}
            </div>
          </div>
          {/* )}*/}
        </div>
        {/* 
        <div className="flex-send-form">
          <div className="send-form">
            <form className="form-display">
              <input
                type="text"
                name="formName"
                value={dropdownState.textAreaContentOeil}
                onChange={handleNameChange}
                placeholder="Nom de la fiche"
              />
              <button
                className="btn-form"
                type="button"
                onClick={handleSavePage}
              >
                <FaSave size={20} color="white" />
              </button>
            </form>
            <div className="dropdown-footer-container">
              <p className="dropdown-footer">
                Vous pouvez fermer cette fiche et revenir dessus plus tard,
                l’enregistrement est automatique
              </p>
            </div>
          </div>
        </div>*/}
      </div>

      <script
        src="https://kit.fontawesome.com/7a4c34e63c.js"
        crossOrigin="anonymous"
      ></script>
    </div>
  );
}

export default DropdownPage;
